<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Fichas Cadastrais';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>    
<div class="container">
	<p>Para efetuar o cadastro, baixe os arquivos necessários, preencha, assine e entregue na imobiliária.</p>
	<hr>
	<div class="mb-10">
		<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/fichas/portoCadastroPessoaFisica.pdf">
			<b>Ficha Cadastral - Pessoa Física</b>
		</a>
	</div>
	<div class="mb-10">
		<a class="btn btn-rounded btn-primary" style="border: 2px solid #ffffff !important;" target="_blank" href="/assets/fichas/portoCadastroPessoaJuridica.pdf">
			<b>Ficha Cadastral - Pessoa Jurídica</b>
		</a>
	</div>
	<hr>
	<div class="button text-center">        
		<a href="/documentacao-necessaria" use:link replace title="" class="btn btn-secondary">
			CONFIRA A DOCUMENTAÇÃO PARA LOCAÇÃO <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
		</a>
	</div>
	<br />

</div>